import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ErrorPage({ error }) {
  const { t } = useTranslation();

  const errorCode = error && error.response && error.response.status === 404
    ? '404'
    : 'other';

  return (
    <div className="text-center py-24 sm:py-32">
      <div className="text-8xl sm:text-9xl font-bold text-gray-200 select-none">
        {errorCode === '404' ? '404' : ':('}
      </div>
      <h1 className="text-2xl sm:text-3xl font-bold mt-6 tracking-tight">
        {t(`error.${errorCode}.title`)}
      </h1>
      <p className="text-neutral mt-3 max-w-md mx-auto leading-relaxed">
        {t(`error.${errorCode}.text`)}
      </p>
    </div>
  );
}
